import styled, { css } from 'styled-components'
import { variant } from 'styled-system'

import Text from 'components/Text'
import { colors } from 'utils/colors'

import * as variants from './variants'

type NoResultsProps = {
  className?: string
  icon: JSX.Element
  message: string
  stacking: 'stackRow' | 'stackColumn' | 'invertColumn'
  addOnAfter?: React.ReactNode
}

const NoResults = ({ icon, message, stacking, className, addOnAfter = null }: NoResultsProps) => (
  <Container className={className}>
    <Content variant={stacking}>
      <Icon data-testid="test-id-no-result-icon" variant={stacking}>
        {icon}
      </Icon>
      <StyledText>{message}</StyledText>
      {addOnAfter}
    </Content>
  </Container>
)

const Content = styled.div<{ variant: string }>(() =>
  css(
    {
      display: 'flex',
      alignSelf: 'center',
      justifyContent: 'center',
    },
    variant({ variants }),
  ),
)

const Icon = styled.div<{ variant: string }>(() =>
  css(
    {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    variant({
      variants: {
        stackRow: {
          paddingRight: '8px',
        },
        stackColumn: {
          paddingTop: '24px',
        },
        invertColumn: {
          paddingBottom: '24px',
        },
      },
    }),
  ),
)

const StyledText = styled(Text)`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  color: ${colors.gray5};
`

const genBgImg = (colorHash: string) =>
  `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23${colorHash.substring(
    1,
  )}' stroke-width='2' stroke-dasharray='4%2c4' stroke-dashoffset='73' stroke-linecap='butt'/%3e%3c/svg%3e")`

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-image: ${genBgImg(colors.gray4)};
  border-radius: 4px;
`

export default NoResults
